import { render, staticRenderFns } from "./Qc.vue?vue&type=template&id=275900b4"
import script from "./Qc.vue?vue&type=script&lang=js"
export * from "./Qc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports